import { put } from "redux-saga/effects";
import axios from "../../utils/axios";
import handle from "./handle";
import { GET_INDEX_HEALTHY_DATA, REQ_INDEX_HEALTHY_DATA } from "../../store/healthyDataStore/actionType";
import { GET_VISION_DATA, REQ_VISION_DATA } from "../../store/visionStore/actionType";
import { GET_HISTORY_INDEX_DATA, REQ_HISTORY_INDEX_DATA } from "../../store/healthyHistoryStore/actionType";
import { GLOBAL_STORE } from "../../store/globalStore/actionType";

const api = {
  //获取首页健康数据
  getIndexHealthyData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: true } });
    const res = yield axios ("/shop/index/index", { ...params });
    yield put ({ type: GLOBAL_STORE, store: { infoLoading: false } });
    if (res) {
      const healthyData = yield handle.handleHealthyData (res);
      yield put ({ type: GET_INDEX_HEALTHY_DATA, healthyData });
    }
  },
  //获取首页视力健康
  getIndexVisionData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { visionLoading: true } });
    const res = yield axios ("/shop/vision/index", { ...params });
    yield put ({ type: GLOBAL_STORE, store: { visionLoading: false } });
    if (res) {
      yield put ({ type: GET_VISION_DATA, visionData: res.data });
    }
  },
  //获取首页健康史
  getHealthyIndexData: function * ({ params }) {
    yield put ({ type: GLOBAL_STORE, store: { historyLoading: true } });
    const res = yield axios ("/shop/history/index", { ...params });
    yield put ({ type: GLOBAL_STORE, store: { historyLoading: false } });
    if (res && res.data) {
      yield put ({ type: GET_HISTORY_INDEX_DATA, historyData: res.data });
    }
  },
  getShareWxConfig: (data) => {
    //return axios ("/userapi/wx/web/jsconfig", data);
    return axios ("/authapi/wx/jsconfig", data)
  },
  getUserInfo: (params) => {
    //return axios (`/userapi/user/auth/detail?sid=${params.sid}`);
    return axios (`/userapi/user-info`)
    
  },
  joinCompany: (params) => {
    return axios (`/userapi/user/auth/joincompany?sid=${params.sid}`, params, false, "POST");
  },
  getUser: (params) => {
    // return axios ("/userapi/open/common/user/detail", { ...params });
    return axios ("/userapi/user-info", { ...params });
   
  },
  getCompletion: (params) => {
    return axios ("/shop/relation/completion", { ...params });
  },
  getChineseMedicineReportCount: (params) => {
    // return axios ("/testapi/report/get_report_list", { ...params });
    return axios ("/api/report/list", { ...params });
  },
  getWestMedicineReportCount: (params) => {
    return axios ("/shop/report/index", params);
  }
};
export { REQ_INDEX_HEALTHY_DATA, REQ_VISION_DATA, REQ_HISTORY_INDEX_DATA };
export default api;

